import { render, staticRenderFns } from "./MenuCard.vue?vue&type=template&id=70629673&"
import script from "./MenuCard.vue?vue&type=script&lang=js&"
export * from "./MenuCard.vue?vue&type=script&lang=js&"
import style0 from "./MenuCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports